module.exports = __webpack_public_path__ + "img/dview_shujuku.bfbcacb0.jpg";